import axios from "axios";
import { Constants } from "../constants";

export const getApiService = {
  async getFormText() {
    // CHANGE DEPLOY ACP / DEV
    // Pour déployer dans les serveurs d'acceptation, utiliser : Constants.ENV.acp
    // Pour déployer dans les serveurs de développement, utiliser : Constants.ENV.dev
    const domain = Constants.ENV.prod.baseUrl;
    const url = domain + "web/refTexteFormulaireJson";
    let config = {
      headers: {
        Accept: "application/json"
      }
    };
    // recuperation du json
    const resultFormText = await axios.get(url, config);
    try {
      return resultFormText;
    } catch (error) {
      // affichage de l'erreur
      console.debug(error);
    }
  },
  async getFormTextSelect() {
    // CHANGE DEPLOY ACP / DEV
    // Pour déployer dans les serveurs d'acceptation, utiliser : Constants.ENV.acp
    // Pour déployer dans les serveurs de développement, utiliser : Constants.ENV.dev
    const domain = Constants.ENV.prod.baseUrl;
    const url = domain + "web/newRefTablesJson";
    let config = {
      headers: {
        'Accept': "application/json",
      }
    };
    // recuperation du json
    const resultFormText = await axios.get(url, config);
    try {
      return resultFormText;
    } catch (error) {
      // affichage de l'erreur
      console.debug(error);
    }
  },
  async getLoCode(countryCode, regionCode, cityCode) {
    if (!countryCode || !cityCode) {
      console.debug('[WARN - getLoCode] countryCode and cityCode cannot be null');
      return;
    }
    // CHANGE DEPLOY ACP / DEV
    // Pour déployer dans les serveurs d'acceptation, utiliser : Constants.ENV.acp
    // Pour déployer dans les serveurs de développement, utiliser : Constants.ENV.dev
    const _baseUrl = Constants.ENV.prod.baseUrl + "web/loCode/";
    const url = regionCode ?
      _baseUrl + countryCode + "/" + regionCode + "/" + cityCode:
      _baseUrl + countryCode + "/" + cityCode;
    let config = {
      headers: {
        Accept: "application/json"
      }
    };
    // recuperation du json
    const resultOptionsCity = await axios.get(url, config);
    try {
      return resultOptionsCity;
    } catch (error) {
      // affichage de l'erreur
      console.debug(error);
    }
  },
  async validateTokenFromEmail(token) {
    // CHANGE DEPLOY ACP / DEV
    // Pour déployer dans les serveurs d'acceptation, utiliser : Constants.ENV.acp
    // Pour déployer dans les serveurs de développement, utiliser : Constants.ENV.dev
    const domain = Constants.ENV.prod.baseUrl;
    const url = domain + "web/formulaireWeb/infosDemande/" + token;

    let config = {
      headers: {
        Accept: "application/json"
      }
    };
    // recuperation du json
    return await axios.get(url, config)
      .then(res => {
        return res;
      })
      .catch(error => {
        console.debug('[ERROR - getApiService - validateTokenFromEmail] error: %o', error);
        return error;
      });
  },
	async getIsniFormsFromToken(token) {
		// CHANGE DEPLOY ACP / DEV
		// Pour déployer dans les serveurs d'acceptation, utiliser : Constants.ENV.acp
		// Pour déployer dans les serveurs de développement, utiliser : Constants.ENV.dev
		const domain = Constants.ENV.prod.baseUrl;
		const url = domain + "web/formulaireWeb/revision/" + token;

		let config = {
			headers: {
				Accept: "application/json"
			}
		};
		// recuperation du json
		return await axios.get(url, config)
			.then(res => {
				return res;
			})
			.catch(error => {
        console.debug('[ERROR - getApiService - getIsniFormsFromToken] error: %o', error);
				return error;
			});
	}
};
